/* eslint-disable react/prop-types */
import React from 'react';
import MuiListItemIcon from '@mui/material/ListItemIcon';

const ListItemIcon = (props) => <MuiListItemIcon {...props} />;
export default ListItemIcon;
